<mat-form-field appearance="outline">
  <mat-label *ngIf="selectLabel">{{ selectLabel }}</mat-label>
  <mat-select
    [disabled]="disabled"
    [required]="required"
    [value]="value"
    i18n-placeholder
    placeholder="Not applied"
    (selectionChange)="_emitChangeEvent($event.value)"
  >
    <mat-select-trigger>
      <ng-container>
        <mat-icon *ngIf="value | rdsNullParameterIcon as icon" class="rds-c-null-filter-option-icon">{{ icon }}</mat-icon>
        <span [innerHTML]="value | rdsNullParameterLabel"></span>
      </ng-container>
    </mat-select-trigger>
    <mat-option *ngFor="let option of _options" [value]="option.type">
      <mat-icon>{{ option | rdsNullParameterOptionIcon }}</mat-icon
      ><span [innerHTML]="option.label"></span>
    </mat-option>
  </mat-select>
</mat-form-field>
